<div class="flex flex-col justify-center text-center bg-white rounded-xl p-2">
  <p class="mt-0 font-theme-source text-sm pl-2 pr-2 text-left">
    <span class=" mr-1">Informations</span> ·
    <span class="mr-1 ml-1">Recherche</span> ·
    <span class="ml-1 font-bold underline">Finalisation</span>
  </p>

  <div class="mt-5 w-full md:w-[576px] ml-auto mr-auto">
    <div class="flex flex-col w-full justify-center items-center text-left " >
      <div class="m-auto max-w-[400px] w-full bg-theme-orange border-2 border-white p-2 mt-5 mb-5 rounded-xl font-bold text-center" *ngIf="paymentContext()?.error">
        <p class="font-theme-source text-white">{{paymentContext().error}}</p>
      </div>
      <div class="m-auto max-w-[400px] w-full bg-theme-orange border-2 border-white p-2 mt-5 mb-5 rounded-xl font-bold text-center" *ngIf="phoneAlreadyUsed()">
        <p class="font-theme-source text-white">Il existe déja une inscription avec ce numéro de téléphone et un prénom différent, utilise un autre numéro de téléphone.</p>
      </div>

      <div *ngIf="paymentContext()?.error && paymentContext()?.showNextSession && sessionResources.session.value()?.nextSessionId" class="w-full mt-2 mb-5 text-center">
        <app-lp-button text="S'inscrire pour le prochain évenement disponible" [routerLink]="['/show', sessionResources.session.value()?.nextSessionId]"></app-lp-button>
      </div>

      <div class="w-full p-2 flex flex-col text-center mb-5" *ngIf="(paymentContext().loading && !paymentContext().authenticationInProgress) || subscriptionResources.calculatePrice.isLoading()">
        <dotlottie-player src="https://lottie.host/ba40fb0a-457a-48f7-ad33-5c09fac64cea/geqO8yjDER.lottie"
                          background="transparent"
                          speed="1"
                          style="width: 25%; height: auto; margin: auto"
                          direction="1"
                          playMode="normal"
                          loop autoplay>
        </dotlottie-player>
        <p class="w-full text-center font-theme-source text-theme-black font-bold -mt-4">Merci de patienter...</p>
      </div>

      <div class="w-full flex flex-col text-center mb-2">
        <p *ngIf="paymentContext().authenticationInProgress" class="font-theme-source text-base font-bold mb-2">Nous devons vérifier ton identité</p>
        <app-auth-by-phone></app-auth-by-phone>
      </div>

      <div class="w-full" [class.pt-5]="paymentContext().loaded" *ngIf="payPalConfig">
        <app-paypal class="p-0" [config]="payPalConfig" tabindex="6" [paymentContext]="paymentContext"></app-paypal>
      </div>

      <div *ngIf="!paymentContext().loaded
        && sessionResources.session.value()
        && !subscriptionResources.calculatePrice.isLoading()
        && !(paymentContext()?.error && paymentContext()?.showNextSession)
        && leadResources.currentLead.hasValue()" class="flex flex-col justify-center text-left mt-0 w-full">

        <app-payment-button *ngIf="payInPlacePayment.payInPlaceOption && !paymentContext().loading && !(paymentContext().orderCreated && !paymentContext().captured)
                          && subscriptionResources.calculatePrice.value()?.totalPrice > 0
                          && payInPlacePayment.isEligible()"  [tabIndex]="4"
                            paymentMode="in_place" text="Payer sur place (+{{payInPlacePayment.payInPlaceOption.price | showPrice}})"
                            class="mt-2" (onClick)="payInPlacePayment.pay()" color="green-110"></app-payment-button>

        <app-payment-button *ngIf="!paymentContext().loading && !(paymentContext().orderCreated && !paymentContext().captured)
                          && subscriptionResources.calculatePrice.value()?.totalPrice === 0" [tabIndex]="5"
                            text="Valider ton inscription"
                            class="mt-1" (onClick)="offerSubscriptionPayment.pay()" color="green-110"></app-payment-button>

        <app-payment-button *ngIf="!paymentContext().loading && !(paymentContext().orderCreated && !paymentContext().captured)
                          && bankTranferPayment.isEligible()
                          && subscriptionResources.calculatePrice.value()?.totalPrice > 0"  [tabIndex]="5"
                            paymentMode="bank_transker" text="Virement bancaire"
                            class="mt-1" (onClick)="bankTranferPayment.pay()" color="purple-110"></app-payment-button>

      </div>
    </div>
  </div>
</div>


